import { render, staticRenderFns } from "./updateClientResponsible.vue?vue&type=template&id=06710c3c"
import script from "./updateClientResponsible.vue?vue&type=script&lang=js"
export * from "./updateClientResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06710c3c')) {
      api.createRecord('06710c3c', component.options)
    } else {
      api.reload('06710c3c', component.options)
    }
    module.hot.accept("./updateClientResponsible.vue?vue&type=template&id=06710c3c", function () {
      api.rerender('06710c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/components/updateClientResponsible.vue"
export default component.exports